export default __webpack_public_path__ + "static/media/record_bar-orange.68813075.svg";